import React from 'react'
import { IIconProps } from 'Interfaces'

export function InformationCircleIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 24} height={props.height ?? 24} viewBox="0 0 24 24" fill="none">
        <path d="M12 0C5.35385 0 0 5.35385 0 12C0 18.6462 5.35385 24 12 24C18.6462 24 24 18.6462 24 12C24 5.35385 18.6462 0 12 0ZM12 22.1538C6.36923 22.1538 1.84615 17.6308 1.84615 12C1.84615 6.36923 6.36923 1.84615 12 1.84615C17.6308 1.84615 22.1538 6.36923 22.1538 12C22.1538 17.6308 17.6308 22.1538 12 22.1538Z" fill="currentColor"/>
        <path d="M12.9231 9.23077H9.23077V11.0769H11.0769V16.6154H9.23077V18.4615H14.7692V16.6154H12.9231V9.23077Z" fill="currentColor"/>
        <path d="M12 7.38462C12.7647 7.38462 13.3846 6.7647 13.3846 6C13.3846 5.2353 12.7647 4.61538 12 4.61538C11.2353 4.61538 10.6154 5.2353 10.6154 6C10.6154 6.7647 11.2353 7.38462 12 7.38462Z" fill="currentColor"/>
    </svg>        
    )
}